/**
 * An instant as a reader says it: „dzisiaj, 14:20", „wczoraj, 09:05", „15 paź, 09:05", and the year
 * once it is not this one („15 paź 2025, 09:05"). In the reader's own zone. Pure.
 */

import { calendarDaysSince } from './calendarDate';
import { dateTimeFormat, relativeTimeFormat } from './intlCache';

export function instantWhen(at: number, now: number, locale: string): string {
  const then = new Date(at);
  const clock = dateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(then);
  const days = calendarDaysSince(then, new Date(now));
  // `calendarDaysSince` reports a future instant (clock skew) as today.
  if (days === 0 || days === 1) {
    const word = relativeTimeFormat(locale, { numeric: 'auto' }).format(-days, 'day');
    return `${word}, ${clock}`;
  }
  const sameYear = then.getFullYear() === new Date(now).getFullYear();
  const day = dateTimeFormat(
    locale,
    sameYear ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short', year: 'numeric' },
  ).format(then);
  return `${day}, ${clock}`;
}
